import { gql } from '@apollo/client';
import {
  BrandUpdateMutationFragment,
  BrandCreateMutationFragment,
} from '../fragments-hg';

export const SetBrandDefaultMutation = gql`
  mutation setDefaultBrand($id: ID!, $owner: BrandOwnerInput!) {
    setDefaultBrand(id: $id, owner: $owner) {
      id
      isDefault
    }
  }
`;

export const CreateBrandMutation = gql`
  mutation createBrand($input: CreateBrandInput!) {
    createBrand(input: $input) {
      ...brandDetails
    }
  }
  ${BrandCreateMutationFragment}
`;

export const UpdateBrandMutation = gql`
  mutation updateBrand($input: UpdateBrandInput!) {
    updateBrand(input: $input) {
      ...brandDetails
    }
  }
  ${BrandUpdateMutationFragment}
`;

export const ClearBrandDefaultMutation = gql`
  mutation clearDefaultBrand($owner: BrandOwnerInput!) {
    clearDefaultBrand(owner: $owner) {
      id
      isDefault
    }
  }
`;

export const DeleteBrandMutation = gql`
  mutation deleteBrand($id: ID!, $owner: BrandOwnerInput!) {
    deleteBrand(id: $id, owner: $owner) {
      id
    }
  }
`;

export const DeleteAssetMutation = gql`
  mutation deleteAsset($input: DeleteBrandingAssetInput!) {
    deleteBrandingAsset(input: $input) {
      success
      successMessage
    }
  }
`;

export const ApplyCoverToAllBrandsMutation = gql`
  mutation applyCoverToAllBrands($owner: BrandOwnerInput!, $brandId: String!) {
    applyCoverToAllBrands(owner: $owner, brandId: $brandId) {
      id
    }
  }
`;
